import { render, staticRenderFns } from "./event-detail.vue?vue&type=template&id=75463e02&"
import script from "./event-detail.vue?vue&type=script&lang=ts&"
export * from "./event-detail.vue?vue&type=script&lang=ts&"
import style0 from "./event-detail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports